<template>
  <el-dialog
    :title="title"
    width="600px"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    class="dialog"
  >
    <el-form :model="form" :rules="rules" label-width="100px" class="from"  ref="ruleForm">
        <el-row :gutter="10">
            <el-col :span="20">
                <el-form-item label="服务平台"  prop="siteName">
                    <advance-dialog
                        v-model="form.siteName"
                        :params="siteParams"
                        :mValue="form.siteName"
                        :disabled="title === '编辑'"
                        @getAdvanceValue="getSelectValue">
                    </advance-dialog>
                </el-form-item>
            </el-col>
            <el-col :span="20">
                <el-form-item label="仓库"  prop="whName">
                    <advance-dialog
                        v-model="form.whName"
                        :params="whParams"
                        :mValue="form.whName"
                        :disabled="title === '编辑'"
                        @getAdvanceValue="getSelectValue">
                    </advance-dialog>
                </el-form-item>
            </el-col>
            <el-col :span="20">
                <el-form-item label="装货预约">
                    <el-checkbox  v-model="form.innerFlag" true-label="1" false-label="0" disabled>内部业务</el-checkbox>
                    <el-checkbox  v-model="form.mideaFlag" true-label="1" false-label="0" disabled>美的渠道</el-checkbox>
                    <el-checkbox  v-model="form.externalFlag" true-label="1" false-label="0">外部业务</el-checkbox>
                </el-form-item>
            </el-col>
            <el-col :span="20">
                <el-form-item label="状态"  prop="activeFlag">
                    <el-select v-model="form.activeFlag" placeholder="请选择状态">
                        <el-option label="停用" value='0'></el-option>
                        <el-option label="启用" value='1'></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
             <el-col :span="20">
               <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" maxlength="200" rows="6"
                        show-word-limit clearable
                        v-model.trim="form.remark"
                    ></el-input>
                </el-form-item>
            </el-col>
        </el-row>
  </el-form>
  <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSure" :loading="loading">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import advanceDialog from '@/components/lots/otpAdvance';
import { operateOrderConfigUpdate, operateOrderConfigAdd } from '@otp/api/configCenter/operateOrder';

export default {
    components: { advanceDialog },
    data() {
        return {
            basicProps: { multiple: true },
            form: {
                siteCode: '',
                siteName: '',
                whName: '',
                whCode: '',
                innerFlag: '1',
                mideaFlag: '1',
                externalFlag: '0',
                activeFlag: '1',
                remark: ''
            },
            loading: false,
            siteParams: {
                name: '服务平台',
                value: 'siteName',
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' }
                ],
                method: 'post',
                prefix: '/api-tms/',
                advanceUrl: '/user/auth/data/site/query',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
            },
            whParams: {
                name: '仓库',
                value: 'whName',
                advanceConfig: [
                    { prop: 'cdwhName', value: '仓库名称' },
                    { prop: 'whCode', value: '仓库编码' }
                ],
                tableConfig: [
                    { prop: 'whCode', value: '仓库编码' },
                    { prop: 'cdwhName', value: '仓库名称' }
                ],
                advanceUrl: 'cdWarehouse/search?cdwhIsStop=0',
                type: 'advance',
                cbParams: [
                    'whCode', 'cdwhName#whName'
                ]
            },
            rules: {
                activeFlag: [
                    { required: true, message: '请选择是否启用', trigger: 'change' }
                ],
                siteName: [
                    { required: true, message: '请选择服务平台', trigger: 'change' }
                ],
                whName: [
                    { required: true, message: '请选择仓库', trigger: 'change' }
                ]
            }
        };
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '新增'
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    mounted() {
        if (this.title === '编辑') {
            this.form = JSON.parse(JSON.stringify(this.rowData));
        }
    },
    methods: {
        getSelectValue (data, label) {
            this.form = {
                ...this.form,
                ...data
            };
        },
        handleClose() {
            this.form = {};
            this.$emit('handleClose');
        },

        handleSure() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    if (this.form.id) {
                        operateOrderConfigUpdate(this.form).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('编辑成功');
                                this.form = {};
                                this.$emit('handleClose', true);
                            }
                        }).finally(() => {
                            this.loading = false;
                        });
                    } else {
                        operateOrderConfigAdd(this.form).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('新增成功');
                                this.form = {};
                                this.$emit('handleClose', true);
                            }
                        }).finally(() => {
                            this.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.dialog{
    .el-date-editor--datetimerange.el-input__inner, .el-select {
        width: 100%;
    }
    /deep/ .el-form-item__error {
        padding-top:0px !important
    }
    .from{
        .el-form-item__content .el-input-group {
            vertical-align: middle;
        }
        .el-form-item__label,.el-form-item__content {
            line-height: 40px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
    }
}
</style>
